export const LOADER_SHOW_LOADER = "LOADER_SHOW_LOADER";
export const LOADER_HIDE_LOADER = "LOADER_HIDE_LOADER";
